import { ReportProfileAlertResourcesBaseModel } from '../../../report-profile-alert-resources-base-model';
import { SharePointGroupMemberModel } from '../../../microsoft/sharepoint/share-point-group-member-model';

export class SharePointReportProfileAlertAdministratorsModel extends ReportProfileAlertResourcesBaseModel {
  administrators: SharePointGroupMemberModel[];
  invalidAdministratorList: number[];
}
